import { useState } from "react";
import Api from "../../utils/Api";
import { API_ROUTE_REMOVE_MAPPING } from "../../routes";
import { BisListingMappedStrings } from "../../components/media/bisListingMapped/locale";

export default function useDissociateMapping() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const dissociateMapping = async (
    mediaId,
    mediaMappingIds = [],
    onSuccess,
  ) => {
    if (!mediaId || !mediaMappingIds.length) return;

    setIsLoading(true);
    setError(null);

    try {
      await Promise.all(
        mediaMappingIds.map((id) =>
          Api.put(API_ROUTE_REMOVE_MAPPING, null, {
            params: { mediaMappingId: id },
          }),
        ),
      );

      if (onSuccess) onSuccess();
    } catch (err) {
      const message =
        err?.response?.data?.detail ||
        BisListingMappedStrings?.dissociationFailed;
      setError(message);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    dissociateMapping,
  };
}
